<template>
    <div class="footnote">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Footnote'
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";
</style>
